const faqItems = document.querySelectorAll(".faq-item");

faqItems.forEach(item => {
  const button = item.querySelector("button");

  button.addEventListener("click", (e) => {
    const wasOpen = e.target.closest('div.faq-item').classList.contains('expanded');
    faqItems.forEach(faq => {
      faq.classList.remove("expanded");
    });
    if (!wasOpen) item.classList.add("expanded");
  });
});